export default "__VITE_ASSET__YsLJ3KAu__"